import { render } from "./TramitesAsignados.vue?vue&type=template&id=650a8e95&scoped=true"
import script from "./TramitesAsignados.vue?vue&type=script&lang=js"
export * from "./TramitesAsignados.vue?vue&type=script&lang=js"

import "./TramitesAsignados.vue?vue&type=style&index=0&id=650a8e95&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650a8e95"]])

export default __exports__